module.exports = __webpack_public_path__ + "assets/qr-code-bg-74c366ed.png";